import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegistroPage = lazy(() => import('../pages/registro/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AsistentesPage = lazy(() => import('../pages/dashboard/asistentes/page'));
const ConfiguracionPage = lazy(() => import('../pages/dashboard/configuracion/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacidadPage = lazy(() => import('../pages/privacidad/page'));
const TerminosPage = lazy(() => import('../pages/terminos/page'));
const IntegracionesPage = lazy(() => import('../pages/integraciones/page'));
const ApiPage = lazy(() => import('../pages/api/page'));
const DocumentacionPage = lazy(() => import('../pages/documentacion/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const CasosDeExitoPage = lazy(() => import('../pages/casos-de-exito/page'));
const SobreNosotrosPage = lazy(() => import('../pages/sobre-nosotros/page'));
const CaracteristicasPage = lazy(() => import('../pages/caracteristicas/page'));
const PreciosPage = lazy(() => import('../pages/precios/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const IAAndesProcessPage = lazy(() => import('../pages/ia-andes-process/page'));
const ComoFuncionaPage = lazy(() => import('../pages/como-funciona/page'));

// WhatsApp Docs
const WAConnectBot = lazy(() => import('../pages/documentacion/whatsapp/connect-bot/page'));
const WABotManager = lazy(() => import('../pages/documentacion/whatsapp/bot-manager/page'));
const WASubscriberManager = lazy(() => import('../pages/documentacion/whatsapp/subscriber-manager/page'));
const WABroadcasting = lazy(() => import('../pages/documentacion/whatsapp/broadcasting/page'));
const WALiveChat = lazy(() => import('../pages/documentacion/whatsapp/livechat/page'));
const WAWebhookWorkflow = lazy(() => import('../pages/documentacion/whatsapp/webhook-workflow/page'));
const WACatalogue = lazy(() => import('../pages/documentacion/whatsapp/catalogue/page'));

// Telegram Docs
const TGConnectBot = lazy(() => import('../pages/documentacion/telegram/connect-bot/page'));
const TGBotManager = lazy(() => import('../pages/documentacion/telegram/bot-manager/page'));
const TGGroupManager = lazy(() => import('../pages/documentacion/telegram/group-manager/page'));
const TGSubscriberManager = lazy(() => import('../pages/documentacion/telegram/subscriber-manager/page'));
const TGBroadcasting = lazy(() => import('../pages/documentacion/telegram/broadcasting/page'));
const TGLiveChat = lazy(() => import('../pages/documentacion/telegram/livechat/page'));

// Management Docs
const MgmtIntegration = lazy(() => import('../pages/documentacion/management/integration/page'));
const MgmtTeam = lazy(() => import('../pages/documentacion/management/team/page'));
const MgmtTransactions = lazy(() => import('../pages/documentacion/management/transactions/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/caracteristicas',
    element: <CaracteristicasPage />,
  },
  {
    path: '/ia-andes-process',
    element: <IAAndesProcessPage />,
  },
  {
    path: '/como-funciona',
    element: <ComoFuncionaPage />,
  },
  {
    path: '/precios',
    element: <PreciosPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/registro',
    element: <RegistroPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/privacidad',
    element: <PrivacidadPage />,
  },
  {
    path: '/terminos',
    element: <TerminosPage />,
  },
  {
    path: '/integraciones',
    element: <IntegracionesPage />,
  },
  {
    path: '/api',
    element: <ApiPage />,
  },
  {
    path: '/documentacion',
    element: <DocumentacionPage />,
  },
  // WhatsApp Docs
  {
    path: '/documentacion/whatsapp/connect-bot',
    element: <WAConnectBot />,
  },
  {
    path: '/documentacion/whatsapp/bot-manager',
    element: <WABotManager />,
  },
  {
    path: '/documentacion/whatsapp/subscriber-manager',
    element: <WASubscriberManager />,
  },
  {
    path: '/documentacion/whatsapp/broadcasting',
    element: <WABroadcasting />,
  },
  {
    path: '/documentacion/whatsapp/livechat',
    element: <WALiveChat />,
  },
  {
    path: '/documentacion/whatsapp/webhook-workflow',
    element: <WAWebhookWorkflow />,
  },
  {
    path: '/documentacion/whatsapp/catalogue',
    element: <WACatalogue />,
  },
  // Telegram Docs
  {
    path: '/documentacion/telegram/connect-bot',
    element: <TGConnectBot />,
  },
  {
    path: '/documentacion/telegram/bot-manager',
    element: <TGBotManager />,
  },
  {
    path: '/documentacion/telegram/group-manager',
    element: <TGGroupManager />,
  },
  {
    path: '/documentacion/telegram/subscriber-manager',
    element: <TGSubscriberManager />,
  },
  {
    path: '/documentacion/telegram/broadcasting',
    element: <TGBroadcasting />,
  },
  {
    path: '/documentacion/telegram/livechat',
    element: <TGLiveChat />,
  },
  // Management Docs
  {
    path: '/documentacion/management/integration',
    element: <MgmtIntegration />,
  },
  {
    path: '/documentacion/management/team',
    element: <MgmtTeam />,
  },
  {
    path: '/documentacion/management/transactions',
    element: <MgmtTransactions />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/casos-de-exito',
    element: <CasosDeExitoPage />,
  },
  {
    path: '/sobre-nosotros',
    element: <SobreNosotrosPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard/asistentes',
    element: <AsistentesPage />,
  },
  {
    path: '/dashboard/configuracion',
    element: <ConfiguracionPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
